<template>
  <figure
    id="selectorIllustration"
    class="c-illustration"
  >
    <responsive-image
      v-if="image"
      :id="image.id"
      :css="'c-illustration__bgimg'"
      v-on:image-size="updateImageSize"
      :alt="illustration.name"
    />

    <svg
      v-if="selectedBuilding != 'all'"
      :view-box.camel="viewBox"
      class="c-illustration__svg c-illustration__residence"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ShapeComponent
        v-for="shape in shapes"
        :key="shape.id"
        :id="shape.id"
        :type="shape.shapeable_type"
      />
    </svg>

    <svg
      v-if="selectedBuilding === 'all'"
      :view-box.camel="viewBox"
      class="c-illustration__svg c-illustration__building"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ShapeComponent
        v-for="shape in shapes"
        :key="shape.id"
        :id="shape.id"
        :type="shape.shapeable_type"
      />
    </svg>

    <compass-arrow
      v-if="illustration.hasCompass === true"
      :rotation="illustration.compassAngle"
    />
  </figure>
</template>

<script>
import { EventBus, } from '@/event-bus.js';

import Illustration from '@/models/Illustration.js';
import Image from '@/models/Image.js';
import Shape from '@/models/Shape.js';

import ResponsiveImage from '@/components/ResponsiveImage.vue';
import ShapeComponent from '@/components/Shape.vue';
import CompassArrow from '@/components/CompassArrow.vue';

export default {
  name: 'SelectorIllustration',
  components: {
    ShapeComponent,
    ResponsiveImage,
    CompassArrow,
  },
  props: {
    illustrationId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      width: 1800,
      height: 1200,
    };
  },
  computed: {
    illustration() {
      return Illustration.find(this.illustrationId);
    },
    shapes() {
      return Shape.query()
        .where('illustration', this.illustrationId)
        .get();
    },
    image() {
      return Image.query()
        .whereHas('illustrations', query => {
          query.where('id', this.illustrationId);
        })
        .first();
    },
    viewBox() {
      return `0 0 ${this.width} ${this.height}`;
    },
    selectedBuilding() {
      return this.$store.state.entities.buildings.selectedBuilding;
    },
  },
  methods: {
    updateImageSize(size) {
      this.width = size.width;
      this.height = size.height;
    },
  },
};
</script>
